(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battery-safe-logistics"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-battery-safe-logistics-root]';

  const buildQuoteUrl = (baseUrl, selections) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'warehousing-logistics-distribution');
      url.searchParams.set('item', selections.item.value);
      url.searchParams.set('flow', selections.flow.value);
      url.searchParams.set('task', selections.task.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=warehousing-logistics-distribution&item=${encodeURIComponent(selections.item.value)}&flow=${encodeURIComponent(selections.flow.value)}&task=${encodeURIComponent(selections.task.value)}`;
    }
  };

  const getRouteCopy = (selections) => {
    const item = {
      'battery-powered-goods': {
        sentence: 'Battery-powered goods in normal packaging can be treated differently from loose battery inventory, so product configuration and packaging status matter before additional controls are selected.',
        priority: 'Battery configuration, packaging status, receiving condition and warehouse scale'
      },
      'loose-batteries': {
        sentence: 'Loose batteries generally require more explicit storage and transport control because the battery itself is the inventory rather than part of a finished product.',
        priority: 'Battery identity, Wh/chemistry, quantity, packaging and storage/transport basis'
      },
      'warehouse-equipment': {
        sentence: 'Operational warehouse batteries divide into removable scanner/tool batteries and integrated motive-power systems that should remain within the OEM battery/charger architecture.',
        priority: 'Operational battery type, charging demand, OEM charging system and warehouse uptime'
      },
      'returns': {
        sentence: 'A returned battery-powered item has changed custody and may have incomplete condition or packaging history, so triage should come before automatic restock or shipment.',
        priority: 'Return reason, product/battery identity, packaging condition and technical triage'
      },
      'abnormal': {
        sentence: 'A damaged, defective, recalled or end-of-life battery has left the normal logistics route and needs controlled isolation, disposition and transport review.',
        priority: 'Condition, incident/recall history, isolation, movement decision and final disposition'
      }
    }[selections.item.value];

    const flow = {
      'inbound': {
        sentence: 'Inbound receiving is the point to identify inconsistencies between the goods, packaging and declared battery information before they enter normal stock.',
        priority: 'Receiving inspection, declaration consistency, package condition and exception routing'
      },
      'storage': {
        sentence: 'Storage adds quantity, packaging, pallet/rack/ASRS arrangement, dwell time and building fire-protection considerations.',
        priority: 'Inventory scale, rack/pallet arrangement, dwell time, fire protection and insurer/AHJ review'
      },
      'outbound': {
        sentence: 'Pick/pack and outbound staging require the product configuration, battery condition, packing basis and next transport mode to remain aligned.',
        priority: 'Packaging, documentation, next mode, carrier and outbound exception controls'
      },
      'returns': {
        sentence: 'Returns inspection should determine whether an item is serviceable, uncertain or abnormal before it re-enters ordinary inventory.',
        priority: 'Return reason, identity, condition, documentation and restock/quarantine decision'
      },
      'internal-movement': {
        sentence: 'Internal movement needs a defined handling route and destination without being confused with external dangerous-goods transport approval.',
        priority: 'Internal route, handling equipment, payload, condition and destination'
      },
      'carrier-handoff': {
        sentence: 'Carrier handoff requires the actual transport mode, regulatory route, packaging, documentation and current carrier acceptance to be confirmed.',
        priority: 'Transport classification, mode, packaging approval/basis, documentation and carrier acceptance'
      }
    }[selections.flow.value];

    const task = {
      'store-hold': {
        title: 'Confirm status and warehouse scale before selecting storage equipment.',
        copy: 'Define whether the inventory is normal, uncertain or abnormal, then assess packaging, quantity, dwell time, physical arrangement and surrounding fire protection.',
        priorities: ['Inventory status and product/battery configuration', 'Quantity, packaging, rack/pallet arrangement and fire-protection scale']
      },
      'charge-equipment': {
        title: 'Separate removable operational batteries from motive-power charging.',
        copy: 'Scanners, tools and radios can often use controlled charging arrangements; forklift, AGV and AMR charging should remain inside the OEM battery/charger ecosystem.',
        priorities: ['Operational battery inventory and simultaneous charging demand', 'OEM vehicle/battery/charger compatibility where motive power is involved']
      },
      'move-internally': {
        title: 'Internal movement needs a defined handling route and destination.',
        copy: 'Confirm condition, payload, handling equipment and whether the item is moving to normal inventory, QA, returns, quarantine or the shipping area.',
        priorities: ['Condition, handling route, payload and destination', 'Clear separation between internal movement and external transport approval']
      },
      'pack-ship': {
        title: 'External shipment requires the battery condition, mode and packaging basis before handoff.',
        copy: 'Confirm product configuration, battery status, transport mode, packing instruction/permit where applicable, documents and carrier acceptance.',
        priorities: ['Battery configuration, condition and transport classification', 'Packaging basis, mode, documentation and carrier acceptance']
      },
      'triage-return': {
        title: 'Returned does not automatically mean damaged — triage before routing.',
        copy: 'Establish identity, reason for return, package condition and observable battery status before choosing restock, technical review, quarantine or transport.',
        priorities: ['Return reason and product/battery identity', 'Packaging condition, status determination and trained escalation route']
      },
      'isolate': {
        title: 'An abnormal battery should leave the normal fulfilment stream.',
        copy: 'Define who owns the decision, whether movement is appropriate, the controlled holding location and the return, recycling or specialist transport route.',
        priorities: ['Observable condition and stop to normal handling/shipping', 'Isolation, monitoring, technical owner and final disposition']
      }
    }[selections.task.value];

    const motive =
      selections.item.value === 'warehouse-equipment' &&
      selections.task.value === 'charge-equipment';

    const bulk =
      selections.flow.value === 'storage' &&
      (selections.item.value === 'loose-batteries' || selections.item.value === 'battery-powered-goods');

    const externalAbnormal =
      selections.item.value === 'abnormal' &&
      (selections.task.value === 'pack-ship' || selections.flow.value === 'carrier-handoff');

    if (motive) {
      return {
        title: 'Confirm the OEM motive-power charging system first.',
        copy: `${item.sentence} ${flow.sentence} Battery Safe Systems should address separate portable-battery charging, abnormal-battery isolation, fire planning and transport requirements only where those duties are clearly defined.`,
        priorities: [
          'Vehicle + battery + charger compatibility',
          'OEM opportunity-charging / fleet-energy strategy',
          'Warehouse throughput and charger location',
          'Separate scanner/tool battery and abnormal-battery routes'
        ],
        specialist: true
      };
    }

    if (externalAbnormal) {
      return {
        title: 'Dangerous-goods specialist review comes before ordinary shipment.',
        copy: `${item.sentence} ${flow.sentence} Damaged/defective/recalled batteries can face special packaging and transport-mode restrictions, and severely damaged batteries may require specialist arrangements.`,
        priorities: [
          'Battery condition and whether transport is permitted',
          'Applicable damaged/defective packing instruction or special permit',
          'Transport mode — particularly air restrictions',
          'Qualified dangerous-goods shipper and current carrier acceptance'
        ],
        specialist: true
      };
    }

    if (bulk) {
      return {
        title: 'Warehouse-scale battery inventory may need fire-protection review before cabinet selection.',
        copy: `${item.sentence} ${flow.sentence} Define inventory quantity, packaging, storage height/arrangement, dwell time and existing fire protection before deciding whether a cabinet-scale solution is appropriate.`,
        priorities: [
          'Battery/product configuration and inventory quantity',
          'Packaging, pallet/rack/high-pile or ASRS arrangement',
          'Existing sprinkler/detection/fire strategy',
          'Local code/AHJ and insurer/loss-prevention review where scale requires it'
        ],
        specialist: true
      };
    }

    return {
      title: task.title,
      copy: `${task.copy} ${item.sentence} ${flow.sentence}`,
      priorities: [task.priorities[0], task.priorities[1], item.priority, flow.priority],
      specialist: false
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.logisticsInitialized === 'true') return;

    const selector = root.querySelector('[data-logistics-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const selections = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        selections[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return selections;
    };

    const render = () => {
      const selections = getSelections();
      const route = getRouteCopy(selections);
      const label = `${selections.item.label} · ${selections.flow.label} · ${selections.task.label}`;

      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;

      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((text) => {
          const li = document.createElement('li');
          li.textContent = text;
          priorities.appendChild(li);
        });
      }

      if (action) {
        action.href = buildQuoteUrl(baseQuoteUrl, selections);
        action.innerHTML = route.specialist
          ? 'Continue to specialist requirement capture <span aria-hidden="true">→</span>'
          : 'Continue this requirement in the Guided Quote <span aria-hidden="true">→</span>';
      }
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.logisticsInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["battery-safe-retail-repair"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-battery-safe-retail-root]';

  const buildQuoteUrl = (baseUrl, selections) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'retail-returns-repair');
      url.searchParams.set('item', selections.item.value);
      url.searchParams.set('location', selections.location.value);
      url.searchParams.set('task', selections.task.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=retail-returns-repair&item=${encodeURIComponent(selections.item.value)}&location=${encodeURIComponent(selections.location.value)}&task=${encodeURIComponent(selections.task.value)}`;
    }
  };

  const getRouteCopy = (selections) => {
    const item = {
      'new-stock': {
        sentence: 'New/sealed stock normally remains within the ordinary retail inventory route unless its condition, packaging or recall status changes.',
        priority: 'Product/battery type, quantity, normal storage and any in-store charging'
      },
      'customer-return': {
        sentence: 'A customer return has changed custody and may have incomplete condition or charging history, so commercial and technical triage should come before automatic restock or shipment.',
        priority: 'Return reason, battery-related symptoms, condition, modification/repair history and next route'
      },
      'repair-device': {
        sentence: 'A device awaiting repair should follow the manufacturer-supported technical process, with abnormal-battery screening before the technician accesses the battery.',
        priority: 'Device identity, repair scope, OEM/model-specific procedure and abnormal-battery escalation'
      },
      'removed-battery': {
        sentence: 'A removed battery has left the customer-device workflow and needs its own status, holding and downstream recycling/transport route.',
        priority: 'Battery identity, condition, terminal/short-circuit control, collection and recycler/transport route'
      },
      'vape-takeback': {
        sentence: 'Vape takeback should be managed as a defined collection stream without assuming staff should dismantle embedded batteries or mix returned devices into general waste.',
        priority: 'Takeback obligation, collection container, abnormal-item route, collection frequency and downstream waste/transport process'
      },
      'abnormal': {
        sentence: 'A swollen, damaged, overheated, defective or recalled battery/device has left the normal customer or repair flow and needs controlled isolation/disposition.',
        priority: 'Observable condition, incident/recall status, isolation, movement decision and final disposition'
      }
    }[selections.item.value];

    const location = {
      'sales-counter': {
        sentence: 'At the customer counter, the goal is recognition and routing rather than detailed technical diagnosis or unnecessary manipulation.',
        priority: 'Simple intake questions, minimal handling, public access and staff escalation'
      },
      'returns-desk': {
        sentence: 'The returns desk should keep normal commerce fast while identifying the small minority that require technical or abnormal-battery routes.',
        priority: 'Return reason, triage criteria, status labelling and safe handoff'
      },
      'repair-bench': {
        sentence: 'At the repair bench, the technician may physically access the integrated battery, so the model-specific repair method and battery condition become central.',
        priority: 'Technician competence, repair instructions, tool/heat/mechanical control and abnormal-battery stop criteria'
      },
      'back-of-house': {
        sentence: 'Back-of-house areas can contain customer devices, replacement batteries, removed batteries and takeback items, so status segregation matters.',
        priority: 'Physical separation, security, charging activity, collection capacity and abnormal-item route'
      },
      'overnight': {
        sentence: 'Overnight holding adds reduced supervision and makes device status, charging, monitoring and abnormal-item separation especially important.',
        priority: 'Peak overnight quantity, charging/no charging, monitoring, alarm recipient and emergency response'
      },
      'outbound': {
        sentence: 'Outbound movement requires the battery/device condition, packaging, transport mode and carrier route to be confirmed separately from stationary holding.',
        priority: 'Battery condition, transport classification, packaging basis, mode and carrier acceptance'
      }
    }[selections.location.value];

    const task = {
      'store-sell': {
        title: 'Keep normal retail stock in the ordinary stock-control route unless its status changes.',
        copy: 'Confirm product type, quantity, storage arrangement, charging activity if any and applicable premises controls before adding specialist containment.',
        priorities: ['Product/battery configuration and stock quantity', 'Normal storage/charging conditions and separation from returns/abnormal items']
      },
      'triage-return': {
        title: 'Triage the return before restock, repair or outbound shipment.',
        copy: 'Use a short set of condition questions to distinguish commercial returns from technical or battery-abnormal returns without overcomplicating normal customer service.',
        priorities: ['Return reason and any battery-related symptoms', 'Condition, damage/heat/swelling/recall indicators and next responsible route']
      },
      'repair-replace': {
        title: 'Manufacturer-supported repair process first.',
        copy: 'Confirm the device model, supported repair procedure, technician competence, replacement battery compatibility and stop criteria for abnormal battery conditions.',
        priorities: ['OEM/model-specific repair instructions and technician controls', 'Battery condition, compatible replacement part and removed-battery route']
      },
      'store-overnight': {
        title: 'Separate normal overnight devices from abnormal batteries.',
        copy: 'Define how many devices remain overnight, whether any are charging, how they are physically separated and what happens if an alarm/condition changes after closing.',
        priorities: ['Peak overnight device/battery quantity and condition', 'Charging, physical arrangement, monitoring and out-of-hours response']
      },
      'isolate': {
        title: 'An abnormal item should leave the ordinary customer and repair workflow.',
        copy: 'Stop routine handling/charging, define who owns the decision, choose an isolation method supported for the item/condition and establish the downstream return/recycling route.',
        priorities: ['Observable condition and stop to normal repair/charging', 'Isolation suitability, monitoring, technical owner and disposition']
      },
      'return-recycle-ship': {
        title: 'Outbound routing depends on condition as well as destination.',
        copy: 'Confirm whether the item is normal, returned, recalled or damaged/defective, then match the transport package, mode, documentation and carrier acceptance to that status.',
        priorities: ['Battery/device condition and transport classification', 'Packaging/permit basis, mode, carrier acceptance and destination']
      }
    }[selections.task.value];

    const repairAbnormal =
      selections.item.value === 'abnormal' &&
      selections.task.value === 'repair-replace';

    const externalAbnormal =
      selections.item.value === 'abnormal' &&
      (selections.task.value === 'return-recycle-ship' || selections.location.value === 'outbound');

    const vapeDismantle =
      selections.item.value === 'vape-takeback' &&
      selections.task.value === 'repair-replace';

    if (repairAbnormal) {
      return {
        title: 'Do not continue through the ordinary repair queue.',
        copy: `Follow the device manufacturer's abnormal/swollen-battery service process and the site's isolation procedure. ${location.sentence}`,
        priorities: [
          'Stop routine repair/charging unless the manufacturer-supported abnormal-battery process specifically permits it',
          'Minimise unnecessary manipulation',
          'Use the defined abnormal-battery isolation / technical owner route',
          'Escalate to emergency response if the item is heating, venting, smoking or actively failing'
        ],
        specialist: true
      };
    }

    if (externalAbnormal) {
      return {
        title: 'Specialist transport review comes before ordinary parcel return.',
        copy: `${item.sentence} ${location.sentence} Damaged/defective/recalled batteries can have specific packaging and transport-mode restrictions, including air prohibitions in some routes.`,
        priorities: [
          'Confirm whether the battery/device is permitted to travel',
          'Use the applicable damaged/defective/recalled packaging or special-permit route',
          'Confirm road/sea/air/mixed-network restrictions',
          'Use trained dangerous-goods personnel and current carrier acceptance'
        ],
        specialist: true
      };
    }

    if (vapeDismantle) {
      return {
        title: 'Do not create an informal vape-dismantling process.',
        copy: 'A retailer takeback stream should not automatically become a battery-removal operation. Follow the applicable product/waste process and use specialist handling only where dismantling is specifically required and safely supported.',
        priorities: [
          'Keep takeback, abnormal-item and repair functions separate',
          'Do not remove embedded batteries merely to fit an ordinary collection bin',
          'Confirm nicotine/e-liquid and other waste obligations separately',
          'Use downstream recycler/waste contractor instructions'
        ],
        specialist: true
      };
    }

    return {
      title: task.title,
      copy: `${task.copy} ${item.sentence} ${location.sentence}`,
      priorities: [task.priorities[0], task.priorities[1], item.priority, location.priority],
      specialist: false
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.retailInitialized === 'true') return;

    const selector = root.querySelector('[data-retail-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const selections = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        selections[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return selections;
    };

    const render = () => {
      const selections = getSelections();
      const route = getRouteCopy(selections);
      const label = `${selections.item.label} · ${selections.location.label} · ${selections.task.label}`;

      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;

      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((text) => {
          const li = document.createElement('li');
          li.textContent = text;
          priorities.appendChild(li);
        });
      }

      if (action) {
        action.href = buildQuoteUrl(baseQuoteUrl, selections);
        action.innerHTML = route.specialist
          ? 'Continue to specialist requirement capture <span aria-hidden="true">→</span>'
          : 'Continue this requirement in the Guided Quote <span aria-hidden="true">→</span>';
      }
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.retailInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["battery-safe-waste-recycling"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-battery-safe-waste-root]';

  const buildQuoteUrl = (baseUrl, selections) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'waste-recycling');
      url.searchParams.set('facility', selections.facility.value);
      url.searchParams.set('status', selections.status.value);
      url.searchParams.set('task', selections.task.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=waste-recycling&facility=${encodeURIComponent(selections.facility.value)}&status=${encodeURIComponent(selections.status.value)}&task=${encodeURIComponent(selections.task.value)}`;
    }
  };

  const getRouteCopy = (selections) => {
    const facility = {
      'mrf': {
        sentence: 'In a MRF or mixed-recycling operation, the battery is usually an unwanted contaminant and the priority is to intercept it before mechanical processing.',
        priority: 'Battery interception points, safe removal procedure, temporary holding and fire response'
      },
      'landfill': {
        sentence: 'In general waste and landfill operations, collection-vehicle compaction, transfer handling and mixed loads can mechanically damage hidden batteries.',
        priority: 'Inbound identification, compaction risk, safe recovery, temporary storage and fire response'
      },
      'collection': {
        sentence: 'A battery/e-waste collection site intentionally receives batteries and therefore needs acceptance criteria, condition segregation, storage capacity and downstream shipping controls.',
        priority: 'Accepted battery types, terminal/short-circuit control, segregation, capacity and recycler transport'
      },
      'recycler': {
        sentence: 'A battery recycler needs pre-acceptance, non-conforming load management, quarantine capacity and controlled handoff into the specialist treatment process.',
        priority: 'Pre-acceptance data, incoming condition, quarantine, large-format controls and process handoff'
      },
      'scrap': {
        sentence: 'Scrap and dismantling operations may receive batteries still embedded in equipment, making identification/removal before crushing or shredding a key process question.',
        priority: 'Battery-containing equipment identification, dismantling boundary, pre-processing removal and abnormal-battery route'
      }
    }[selections.facility.value];

    const status = {
      'hidden': {
        sentence: 'A hidden battery should be removed from the wrong waste stream before damaging process steps where the facility procedure safely permits.',
        priority: 'Interception point, safe equipment stop/isolation, condition check and dedicated holding'
      },
      'eol': {
        sentence: 'An ordinary end-of-life battery can enter controlled collection/storage, but EOL status does not automatically mean the battery is chemically inert or transport-exempt.',
        priority: 'Battery format, terminal control, storage capacity, condition monitoring and downstream recycler route'
      },
      'uncertain': {
        sentence: 'Mixed or unidentified batteries need a triage/quarantine route until identity, format and condition are sufficiently understood.',
        priority: 'Identification, condition uncertainty, segregation, quarantine capacity and specialist review'
      },
      'ddr': {
        sentence: 'Damaged, defective or recalled batteries should leave the ordinary EOL route and enter dedicated isolation and transport review.',
        priority: 'Observable condition, energy/format, isolation, monitoring and exact DDR transport route'
      },
      'large-format': {
        sentence: 'Large EV/BESS batteries can require HV competence, lifting/handling, fire separation, monitoring and specialist logistics before ordinary container selection.',
        priority: 'HV status, pack energy/weight, lifting/handling, isolation area and specialist transport'
      },
      'processed': {
        sentence: 'Processed materials such as black mass, electrolyte and residues require specialist process-safety controls rather than ordinary intact-battery storage products.',
        priority: 'Process chemistry, smouldering/gas/dust/reactivity hazards and specialist process-safety ownership'
      }
    }[selections.status.value];

    const task = {
      'intercept': {
        title: 'Interception before mechanical processing is the priority.',
        copy: 'Identify and remove the battery before compaction, crushing, shredding or baling where the facility safe procedure permits, then assess condition and route it to dedicated holding.',
        priorities: ['Where in the process the battery can be safely intercepted', 'Safe equipment stop/isolation and removal method']
      },
      'store': {
        title: 'Storage should follow battery condition and downstream route.',
        copy: 'Separate ordinary EOL from uncertain and DDR batteries, then define container capacity, terminal control, monitoring, location and collection frequency.',
        priorities: ['Battery condition/format and peak accumulation', 'Container capacity, terminal control, monitoring and downstream collection']
      },
      'quarantine': {
        title: 'Quarantine needs enough real capacity for the site’s abnormal incoming flow.',
        copy: 'Define what counts as non-conforming or abnormal, how quickly it leaves ordinary reception, the holding method and what happens when quarantine capacity is full.',
        priorities: ['Non-conforming / DDR acceptance criteria', 'Physical capacity, monitoring, segregation and exit route']
      },
      'move': {
        title: 'Internal movement needs a defined handling method and destination.',
        copy: 'Confirm battery condition, size/weight, handling equipment and whether the destination is collection, quarantine, storage or process handoff.',
        priorities: ['Condition, payload and internal route', 'Handling equipment and separation from external transport approval']
      },
      'transport': {
        title: 'Downstream transport depends on condition as well as recycling intent.',
        copy: 'Confirm ordinary EOL versus DDR status, battery format, packaging basis, jurisdiction, mode, documentation and carrier acceptance.',
        priorities: ['Battery condition and transport classification', 'DOT / TDG / ADR or other exact packaging basis and carrier route']
      },
      'process-handoff': {
        title: 'Define the handoff into the recycling process — then stop ordinary product selection there.',
        copy: 'Receiving, segregation and quarantine can be supported with equipment, but deactivation, dismantling, shredding, electrolyte and black-mass processes require specialist process-safety engineering.',
        priorities: ['Accepted feedstock status and readiness for treatment', 'Clear boundary between storage/quarantine equipment and process-engineering controls']
      }
    }[selections.task.value];

    const processed =
      selections.status.value === 'processed' ||
      (selections.facility.value === 'recycler' && selections.task.value === 'process-handoff');

    const largeFormat =
      selections.status.value === 'large-format';

    const ddrTransport =
      selections.status.value === 'ddr' && selections.task.value === 'transport';

    if (processed) {
      return {
        title: 'Specialist recycling-process safety comes before ordinary product selection.',
        copy: `${status.sentence} ${facility.sentence} Battery Safe Systems should only address supporting receiving, quarantine, storage, internal-handling or transport functions.`,
        priorities: [
          'Identify the actual processed material / chemistry / residue',
          'Use specialist process-safety and occupational-hygiene assessment',
          'Define smouldering, gas, dust, reactivity and fire/explosion controls at process level',
          'Select Battery Safe Systems equipment only for supporting intact-battery/quarantine/transport duties'
        ],
        specialist: true
      };
    }

    if (largeFormat) {
      return {
        title: 'Large-format / HV assessment comes before ordinary container selection.',
        copy: `${status.sentence} ${facility.sentence} Establish electrical isolation, lifting/handling, fire separation, monitoring and specialist transport before choosing containment.`,
        priorities: [
          'Pack/module identity, HV status and electrical isolation',
          'Energy, weight, physical damage and lifting/handling method',
          'Dedicated isolation/exclusion arrangement and monitoring',
          'Specialist large-format transport/recycler route'
        ],
        specialist: true
      };
    }

    if (ddrTransport) {
      return {
        title: 'DDR transport needs its own dangerous-goods route.',
        copy: `${status.sentence} ${facility.sentence} Recycling intent does not automatically remove damaged-battery transport requirements.`,
        priorities: [
          'Confirm DDR condition and whether the battery is permitted to travel',
          'Use the exact jurisdiction-specific damaged-battery packaging/special provision',
          'Confirm transport mode restrictions',
          'Use trained dangerous-goods personnel and current carrier acceptance'
        ],
        specialist: true
      };
    }

    return {
      title: task.title,
      copy: `${task.copy} ${facility.sentence} ${status.sentence}`,
      priorities: [task.priorities[0], task.priorities[1], facility.priority, status.priority],
      specialist: false
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.wasteInitialized === 'true') return;

    const selector = root.querySelector('[data-waste-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const selections = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        selections[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return selections;
    };

    const render = () => {
      const selections = getSelections();
      const route = getRouteCopy(selections);
      const label = `${selections.facility.label} · ${selections.status.label} · ${selections.task.label}`;

      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;

      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((text) => {
          const li = document.createElement('li');
          li.textContent = text;
          priorities.appendChild(li);
        });
      }

      if (action) {
        action.href = buildQuoteUrl(baseQuoteUrl, selections);
        action.innerHTML = route.specialist
          ? 'Continue to specialist requirement capture <span aria-hidden="true">→</span>'
          : 'Continue this requirement in the Guided Quote <span aria-hidden="true">→</span>';
      }
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.wasteInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-article-library"]) return;
  try {
    
if (!customElements.get('bss-article-series')) {
  customElements.define('bss-article-series', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
      this.collections = Array.from(this.querySelectorAll('[data-collection]'));
      this.search = this.querySelector('[data-search]');
      this.topic = this.querySelector('select[data-topic]');
      this.availability = this.querySelector('select[data-availability]');
      this.expand = this.querySelector('[data-expand]');
      this.reset = this.querySelector('[data-reset]');
      Array.from(new Set(this.cards.map(card => card.dataset.topic).filter(Boolean))).sort().forEach(topic => {
        const option = document.createElement('option'); option.value = topic; option.textContent = topic; this.topic.append(option);
      });
      this.querySelector('[data-filters]').hidden = false;
      this.expand.hidden = false;
      this.search.addEventListener('input', () => this.update());
      this.topic.addEventListener('change', () => this.update());
      this.availability.addEventListener('change', () => this.update());
      this.reset.addEventListener('click', () => { this.clearFilters(); this.search.focus(); });
      this.expand.addEventListener('click', () => {
        const visible = this.chapters.filter(chapter => !chapter.hidden);
        const open = !visible.every(chapter => chapter.open);
        visible.forEach(chapter => { chapter.open = open; }); this.updateExpand();
      });
      this.chapters.forEach(chapter => chapter.addEventListener('toggle', () => this.updateExpand()));
      this.querySelectorAll('[data-series-jump]').forEach(link => link.addEventListener('click', () => this.clearFilters()));
      this.querySelector('[data-preparation]').addEventListener('click', () => { this.clearFilters(); this.openHash('#foundation-part-6'); });
      this.hashHandler = () => this.openHash(window.location.hash);
      window.addEventListener('hashchange', this.hashHandler);
      this.update(); this.openHash(window.location.hash);
      this.editorHandler = event => { const chapter = event.target.closest('[data-chapter]'); if (chapter) chapter.open = true; };
      this.addEventListener('shopify:block:select', this.editorHandler);
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.hashHandler); }
    clearFilters() { this.search.value = ''; this.topic.value = ''; this.availability.value = ''; this.update(); }
    openHash(hash) {
      if (!hash.startsWith('#foundation-part-')) return;
      const chapter = this.chapters.find(item => '#' + item.id === hash);
      if (chapter) { chapter.open = true; this.updateExpand(); }
    }
    updateExpand() {
      const visible = this.chapters.filter(chapter => !chapter.hidden);
      this.expand.textContent = visible.length && visible.every(chapter => chapter.open) ? this.expand.dataset.collapseLabel : this.expand.dataset.expandLabel;
    }
    update() {
      const terms = this.search.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      const active = Boolean(terms.length || this.topic.value || this.availability.value);
      if (active && !this.wasFiltered) this.savedOpen = this.chapters.map(chapter => chapter.open);
      let published = 0; let planned = 0;
      this.cards.forEach(card => {
        const match = (!this.topic.value || card.dataset.topic === this.topic.value) && (!this.availability.value || card.dataset.availability === this.availability.value) && terms.every(term => card.dataset.text.toLocaleLowerCase().includes(term));
        card.hidden = !match;
        if (match) { if (card.dataset.availability === 'published') published++; else planned++; }
      });
      this.chapters.forEach((chapter, index) => {
        chapter.hidden = !Array.from(chapter.querySelectorAll('[data-card]')).some(card => !card.hidden);
        if (active && !chapter.hidden) chapter.open = true;
        else if (!active && this.wasFiltered) chapter.open = this.savedOpen?.[index] ?? index === 0;
      });
      this.collections.forEach(collection => { collection.hidden = !Array.from(collection.querySelectorAll('[data-card]')).some(card => !card.hidden); });
      this.querySelector('[data-results]').textContent = this.dataset.resultsTemplate.replace('__PUBLISHED__', published).replace('__PLANNED__', planned);
      this.querySelector('[data-empty]').hidden = published + planned > 0;
      this.reset.hidden = !active;
      this.wasFiltered = active;
      this.updateExpand();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-automotive-ev-service"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-bss-auto-root]';

    const buildQuoteUrl = (baseUrl, selections) => {
      try {
        const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
        url.searchParams.set('industry', 'automotive-ev-service');
        url.searchParams.set('asset', selections.asset.value);
        url.searchParams.set('condition', selections.condition.value);
        url.searchParams.set('next_step', selections.next_step.value);

        if (url.origin === window.location.origin) {
          return `${url.pathname}${url.search}${url.hash}`;
        }

        return url.toString();
      } catch (error) {
        const separator = String(baseUrl).includes('?') ? '&' : '?';
        return `${baseUrl}${separator}industry=automotive-ev-service&asset=${encodeURIComponent(selections.asset.value)}&condition=${encodeURIComponent(selections.condition.value)}&next_step=${encodeURIComponent(selections.next_step.value)}`;
      }
    };

    const getRouteCopy = (selections) => {
      const asset = selections.asset.value;
      const condition = selections.condition.value;
      const nextStep = selections.next_step.value;

      if (condition === 'active-deterioration') {
        return {
          title: 'Treat active deterioration as an emergency condition — not a routine product-selection step.',
          copy: 'Heating, venting, smoke, fire or rapid change should move the situation out of the normal service, quarantine or transport workflow. Protect people, restrict access and follow the site emergency plan, OEM emergency information and emergency-service instructions.',
          priorities: [
            'Do not use this selector as permission to move or contain an actively deteriorating battery',
            'Follow the site emergency plan and relevant OEM emergency-response information',
            'Keep people away from the hazard and preserve emergency-service access',
            'Re-enter quarantine, recovery or transport planning only after the emergency condition has been resolved by the appropriate parties'
          ],
          emergency: true
        };
      }

      if (condition === 'uncertain') {
        return {
          title: 'Establish condition before returning the asset to normal workshop flow.',
          copy: 'Collision, flood, underbody impact, battery fault, heat exposure or unclear history can change the next safe step. Use the applicable OEM and qualified assessment pathway before deciding whether routine service, controlled holding, pack removal or onward movement is appropriate.',
          priorities: [
            'What happened, what is observable and what the OEM procedure requires',
            'Whether the asset should remain in a controlled location while condition is resolved',
            'Whether the complete vehicle or a removed battery is being managed',
            'What evidence is required before storage, handling, return or transport'
          ],
          emergency: false
        };
      }

      if (condition === 'damaged-stable') {
        return {
          title: 'A damaged or defective but stable battery needs a defined controlled route.',
          copy: 'Known damage or defect can require separation from normal circulation, monitoring, appropriate handling and a planned disposition route. The suitable equipment depends on asset size, mass, energy, condition, site constraints and whether the requirement is stationary or transport-related.',
          priorities: [
            'Documented condition and OEM or specialist disposition requirements',
            'Dimensions, mass, energy and safe handling interfaces',
            'Controlled quarantine or storage location and monitoring approach',
            'Separate confirmation of any external transport packaging and authorization'
          ],
          emergency: false
        };
      }

      if (nextStep === 'external-transport') {
        return {
          title: 'Transport is a separate approval and packaging decision.',
          copy: 'A stationary quarantine or containment system is not automatically suitable for external transport. Confirm the battery condition, transport mode, destination, packaging basis, carrier requirements and applicable documentation before movement.',
          priorities: [
            'Battery condition and transport classification',
            'Exact pack or module dimensions, mass and energy where documented',
            'Packaging approval, special permit or other applicable transport basis',
            'Carrier, destination, preparation and responsible person'
          ],
          emergency: false
        };
      }

      if (asset === 'removed-traction-pack') {
        return {
          title: 'Once removed, pack geometry, mass, condition and destination drive the equipment requirement.',
          copy: 'A traction pack outside the vehicle becomes a separate heavy stored-energy asset. Confirm its dimensions, mass, lifting interfaces, condition, energy where documented and intended next step before comparing quarantine, handling, storage or transport systems.',
          priorities: [
            'Exact pack dimensions, mass and documented energy',
            'Lifting table, forklift, crane or other handling interface',
            'Indoor/outdoor holding location and monitoring requirement',
            'Stationary use versus eventual return, recycling or external transport'
          ],
          emergency: false
        };
      }

      if (asset === 'module-component') {
        return {
          title: 'Module-level handling still depends on condition, exposed energy and intended duty.',
          copy: 'A smaller component may fit different storage, containment and transport formats than a complete traction pack, but terminal protection, electrical state, physical damage, quantity and onward route still need to be established.',
          priorities: [
            'Component identity and whether it remains electrically live',
            'Terminal protection, damage and packaging condition',
            'Quantity, energy and segregation within the holding area',
            'Return, repair, recycling or external transport requirement'
          ],
          emergency: false
        };
      }

      if (nextStep === 'quarantine-hold') {
        return {
          title: 'Define why the asset is being held and what releases it from quarantine.',
          copy: 'A controlled holding area should have a clear purpose, ownership, monitoring/escalation route and exit condition. Separation distance, duration and release criteria can depend on OEM guidance, incident history, site conditions and local authority expectations.',
          priorities: [
            'Reason for quarantine and responsible decision-maker',
            'Location, surrounding exposures and emergency access',
            'Monitoring, alarms and out-of-hours escalation',
            'Release, repair, return, recycling or transport route'
          ],
          emergency: false
        };
      }

      if (nextStep === 'internal-handling') {
        return {
          title: 'Handling equipment must match the asset — not just its nominal battery capacity.',
          copy: 'For internal movement, physical geometry, mass, centre of gravity, lifting points, clearances and route through the site can matter as much as electrical condition. Use vehicle- or battery-specific handling information where available.',
          priorities: [
            'Dimensions, mass, lifting points and centre-of-gravity information',
            'Rated handling equipment and attachment compatibility',
            'Travel route, floor loading, clearances and turning space',
            'Battery condition and what should happen if condition changes during movement'
          ],
          emergency: false
        };
      }

      return {
        title: 'Routine vehicle service remains OEM- and competence-led.',
        copy: 'For a serviceable complete vehicle, begin with model-specific OEM information, competent high-voltage work practices and the normal workshop process. Battery Safe Systems equipment becomes more relevant if condition changes, the pack is removed, or quarantine, storage, handling or transport is required.',
        priorities: [
          'Vehicle-specific HV isolation and repair procedure',
          'Battery condition and any change from normal service',
          'Complete vehicle versus removed-pack handling requirement',
          'Stationary quarantine versus external transport approval'
        ],
        emergency: false
      };
    };

    const initializeAutoSection = (root) => {
      if (!root || root.dataset.autoInitialized === 'true') return;

      const selector = root.querySelector('[data-auto-model-selector]');
      if (!selector) return;

      const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
      const output = selector.querySelector('[data-decision-output]');
      const kicker = selector.querySelector('[data-decision-kicker]');
      const title = selector.querySelector('[data-decision-title]');
      const copy = selector.querySelector('[data-decision-copy]');
      const priorities = selector.querySelector('[data-decision-priorities]');
      const action = selector.querySelector('[data-decision-action]');
      const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';
      const emergencyUrl = root.dataset.emergencyUrl || '/pages/lithium-battery-emergency-preparedness';

      const getSelections = () => {
        const selections = {};

        groups.forEach((group) => {
          const key = group.dataset.decisionGroup;
          const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');

          selections[key] = {
            value: selected ? selected.dataset.decisionValue : '',
            label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
          };
        });

        return selections;
      };

      const render = () => {
        const selections = getSelections();
        const route = getRouteCopy(selections);
        const routeLabel = `${selections.asset.label} · ${selections.condition.label} · ${selections.next_step.label}`;

        if (output) output.textContent = routeLabel;
        if (kicker) kicker.textContent = routeLabel;
        if (title) title.textContent = route.title;
        if (copy) copy.textContent = route.copy;

        if (priorities) {
          priorities.innerHTML = '';
          route.priorities.forEach((item) => {
            const li = document.createElement('li');
            li.textContent = item;
            priorities.appendChild(li);
          });
        }

        if (action) {
          if (route.emergency) {
            action.href = emergencyUrl;
            action.innerHTML = 'Go to emergency preparedness guidance <span aria-hidden="true">→</span>';
          } else {
            action.href = buildQuoteUrl(baseQuoteUrl, selections);
            action.innerHTML = 'Continue this requirement in the Guided Quote <span aria-hidden="true">→</span>';
          }
        }
      };

      groups.forEach((group) => {
        const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            buttons.forEach((item) => {
              const selected = item === button;
              item.classList.toggle('is-active', selected);
              item.setAttribute('aria-pressed', String(selected));
            });

            render();
          });

          button.addEventListener('keydown', (event) => {
            const index = buttons.indexOf(button);
            let nextIndex = null;

            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              nextIndex = (index + 1) % buttons.length;
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              nextIndex = (index - 1 + buttons.length) % buttons.length;
            } else if (event.key === 'Home') {
              nextIndex = 0;
            } else if (event.key === 'End') {
              nextIndex = buttons.length - 1;
            }

            if (nextIndex !== null) {
              event.preventDefault();
              buttons[nextIndex].focus();
              buttons[nextIndex].click();
            }
          });
        });
      });

      render();
      root.dataset.autoInitialized = 'true';
    };

    const initializeAll = (context = document) => {
      if (context.matches && context.matches(rootSelector)) {
        initializeAutoSection(context);
      }

      if (context.querySelectorAll) {
        context.querySelectorAll(rootSelector).forEach(initializeAutoSection);
      }
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-construction-trades"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-bss-trade-root]';

    const buildQuoteUrl = (baseUrl, selections) => {
      try {
        const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
        url.searchParams.set('industry', 'construction-trades');
        url.searchParams.set('control_model', selections.control_model.value);
        url.searchParams.set('activity', selections.activity.value);
        url.searchParams.set('battery_population', selections.battery_population.value);
        if (url.origin === window.location.origin) return `${url.pathname}${url.search}${url.hash}`;
        return url.toString();
      } catch (error) {
        const separator = String(baseUrl).includes('?') ? '&' : '?';
        return `${baseUrl}${separator}industry=construction-trades&control_model=${encodeURIComponent(selections.control_model.value)}&activity=${encodeURIComponent(selections.activity.value)}&battery_population=${encodeURIComponent(selections.battery_population.value)}`;
      }
    };

    const getRouteCopy = (s) => {
      const model = s.control_model.value;
      const activity = s.activity.value;
      const population = s.battery_population.value;

      const activityRoutes = {
        'storage-charging': {
          title: 'Coordinate inventory, charging throughput and the route out of normal service.',
          copy: 'A combined storage-and-charging requirement needs more than enough sockets. Define total inventory, batteries charging simultaneously, charger demand, charged-battery flow, supervision and the separate route for damaged or uncertain batteries.',
          priorities: [
            'Total battery inventory versus simultaneous charging demand',
            'Charger input ratings, available power and operating hours'
          ]
        },
        'charging': {
          title: 'Charging capacity is a throughput and electrical question before it is a cabinet question.',
          copy: 'Establish how many batteries return at peak periods, how many must charge simultaneously, which chargers are used and whether charging continues outside staffed hours before comparing charging equipment.',
          priorities: [
            'Simultaneous charger positions rather than total battery count',
            'Charger input ratings, available electrical supply and supervision'
          ]
        },
        'storage': {
          title: 'Storage should preserve battery condition and keep abnormal batteries out of normal inventory.',
          copy: 'For serviceable spare or charged batteries, define quantity, state, location, access, environmental exposure and how batteries are separated from chargers, tools and any damaged or uncertain packs.',
          priorities: [
            'Maximum serviceable inventory and physical battery dimensions',
            'Location, access, environmental conditions and charged/spare status'
          ]
        },
        'isolation': {
          title: 'Build a separate route for batteries that should leave normal circulation.',
          copy: 'Construction batteries can be dropped, crushed, wet, overheated or otherwise abnormal. Define who can stop use, where the battery is held, how it is monitored and what happens next before choosing an isolation product.',
          priorities: [
            'Visible condition and event history before further charging or use',
            'Controlled isolation, assessment, return or recycling responsibility'
          ]
        },
        'movement': {
          title: 'Inter-site movement is not the same decision as stationary storage.',
          copy: 'Batteries moving between depots, vans and projects need protection against short circuit, movement and physical damage, while damaged or defective batteries may require a different transport route.',
          priorities: [
            'Battery condition, terminal protection and securement before movement',
            'Actual route, transport classification and packaging requirement'
          ]
        },
        'complete-system': {
          title: 'A complete battery system coordinates normal use, charging, storage, damage and movement.',
          copy: 'Larger contractor operations often need several coordinated arrangements rather than one product. Map how batteries enter the operation, where they are issued and charged, how abnormal packs leave circulation and how batteries move between depots, vans and projects.',
          priorities: [
            'Ownership of each stage from receipt and issue through return and reissue',
            'Interfaces between charging, storage, isolation and transport arrangements'
          ]
        }
      };

      const modelRoutes = {
        'central-tool-store': {
          priority: 'Peak returns, controlled issue/reissue and the capacity of the central tool-store workflow',
          sentence: 'A central tool store gives the business relatively strong control over inspection, charger compatibility, supervision and battery status.'
        },
        'distributed-site': {
          priority: 'Consistent charging locations, temporary electrical supply, housekeeping and supervision across work areas',
          sentence: 'A distributed site trades some central control for convenience, so consistent rules and ownership across several charging or storage points matter more.'
        },
        'van-mobile': {
          priority: 'Vehicle temperature, battery securement, charging supply and the route for a suspect battery discovered away from the depot',
          sentence: 'A mobile team combines storage, transport and sometimes charging in one vehicle workflow, so those duties should be treated separately.'
        },
        'temporary-container': {
          priority: 'Temporary power, siting, access, weather exposure, detection and out-of-hours responsibility',
          sentence: 'A site cabin or container can centralize battery activity, but the enclosure is only one part of the electrical, fire and operating system.'
        },
        'contractor-controlled': {
          priority: 'Common project rules, contractor responsibilities and a shared damaged-battery escalation route',
          sentence: 'Contractor-controlled zones require the principal site rules and individual contractor procedures to meet at clear interfaces.'
        },
        'mixed': {
          priority: 'Clear ownership where central, distributed, mobile and contractor-controlled arrangements interface',
          sentence: 'A mixed operation needs the boundaries between different battery-control models to be explicit so batteries do not fall between procedures.'
        }
      };

      const populationRoutes = {
        'standardized': {
          priority: 'Maintain identification, approved internal process and battery/charger matching across the managed fleet',
          sentence: 'A standardized managed fleet makes compatibility easier to control, but condition checking and charger capacity still need to be managed.'
        },
        'multi-controlled': {
          priority: 'Document which battery systems and chargers are accepted and keep each combination identifiable',
          sentence: 'Multiple controlled brands can share an operation if accepted combinations, charger matching and responsibilities remain clear.'
        },
        'mixed-owner': {
          priority: 'Define acceptance, refusal and reporting rules for contractor- or worker-owned batteries and chargers',
          sentence: 'Mixed ownership increases the importance of a site acceptance policy because the business may not control every battery history or charger.'
        },
        'variable-unknown': {
          priority: 'Establish how unknown, modified, replacement or poorly documented batteries are kept out of routine charging until resolved',
          sentence: 'Where provenance or compatibility is partly unknown, uncertainty itself becomes an operating condition that needs a defined route.'
        }
      };

      const activityRoute = activityRoutes[activity] || activityRoutes['storage-charging'];
      const modelRoute = modelRoutes[model] || modelRoutes['central-tool-store'];
      const populationRoute = populationRoutes[population] || populationRoutes['standardized'];

      return {
        title: activityRoute.title,
        copy: `${activityRoute.copy} ${modelRoute.sentence} ${populationRoute.sentence}`,
        priorities: [
          activityRoute.priorities[0],
          activityRoute.priorities[1],
          modelRoute.priority,
          populationRoute.priority
        ]
      };
    };

    const initialize = (root) => {
      if (!root || root.dataset.tradeInitialized === 'true') return;
      const selector = root.querySelector('[data-trade-model-selector]');
      if (!selector) return;

      const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
      const output = selector.querySelector('[data-decision-output]');
      const kicker = selector.querySelector('[data-decision-kicker]');
      const title = selector.querySelector('[data-decision-title]');
      const copy = selector.querySelector('[data-decision-copy]');
      const priorities = selector.querySelector('[data-decision-priorities]');
      const action = selector.querySelector('[data-decision-action]');
      const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

      const selections = () => {
        const result = {};
        groups.forEach(group => {
          const key = group.dataset.decisionGroup;
          const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
          result[key] = { value: selected ? selected.dataset.decisionValue : '', label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : '' };
        });
        return result;
      };

      const render = () => {
        const s = selections();
        const route = getRouteCopy(s);
        const label = `${s.control_model.label} · ${s.activity.label} · ${s.battery_population.label}`;
        if (output) output.textContent = label;
        if (kicker) kicker.textContent = label;
        if (title) title.textContent = route.title;
        if (copy) copy.textContent = route.copy;
        if (priorities) {
          priorities.innerHTML = '';
          route.priorities.forEach(item => { const li = document.createElement('li'); li.textContent = item; priorities.appendChild(li); });
        }
        if (action) action.href = buildQuoteUrl(baseQuoteUrl, s);
      };

      groups.forEach(group => {
        const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));
        buttons.forEach(button => {
          button.addEventListener('click', () => {
            buttons.forEach(item => { const selected = item === button; item.classList.toggle('is-active', selected); item.setAttribute('aria-pressed', String(selected)); });
            render();
          });
          button.addEventListener('keydown', event => {
            const index = buttons.indexOf(button);
            let next = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = buttons.length - 1;
            if (next !== null) { event.preventDefault(); buttons[next].focus(); buttons[next].click(); }
          });
        });
      });

      render();
      root.dataset.tradeInitialized = 'true';
    };

    const initializeAll = (context = document) => {
      if (context.matches && context.matches(rootSelector)) initialize(context);
      if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-delivery-e-bike-fleets"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-bss-fleet-root]';

    const buildQuoteUrl = (baseUrl, modelKey) => {
      try {
        const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
        url.searchParams.set('industry', 'delivery-e-bike-fleets');
        url.searchParams.set('operating_model', modelKey);

        if (url.origin === window.location.origin) {
          return `${url.pathname}${url.search}${url.hash}`;
        }

        return url.toString();
      } catch (error) {
        const separator = String(baseUrl).includes('?') ? '&' : '?';
        return `${baseUrl}${separator}industry=delivery-e-bike-fleets&operating_model=${encodeURIComponent(modelKey)}`;
      }
    };

    const initializeFleetSection = (root) => {
      if (!root || root.dataset.fleetInitialized === 'true') return;

      const selector = root.querySelector('[data-fleet-model-selector]');
      if (!selector) return;

      const tabs = Array.from(selector.querySelectorAll('[data-model-tab]'));
      const panels = Array.from(selector.querySelectorAll('[data-model-panel]'));
      const output = selector.querySelector('[data-model-output]');
      const quoteLink = selector.querySelector('[data-model-quote-link]');
      const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

      const activateTab = (tab, moveFocus = false) => {
        if (!tab) return;

        const key = tab.dataset.modelTab;
        const label = tab.dataset.modelLabel || tab.textContent.trim();

        tabs.forEach((item) => {
          const isSelected = item === tab;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-selected', String(isSelected));
          item.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        panels.forEach((panel) => {
          const isSelected = panel.dataset.modelPanel === key;
          panel.hidden = !isSelected;
          panel.classList.toggle('is-active', isSelected);
        });

        if (output) output.textContent = label;
        if (quoteLink) quoteLink.href = buildQuoteUrl(baseQuoteUrl, key);
        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));

        tab.addEventListener('keydown', (event) => {
          let nextIndex = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== null) {
            event.preventDefault();
            activateTab(tabs[nextIndex], true);
          }
        });
      });

      const initiallySelected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      activateTab(initiallySelected);
      root.dataset.fleetInitialized = 'true';
    };

    const initializeAll = (context = document) => {
      if (context.matches && context.matches(rootSelector)) {
        initializeFleetSection(context);
      }

      if (context.querySelectorAll) {
        context.querySelectorAll(rootSelector).forEach(initializeFleetSection);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-facilities-commercial-buildings"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-bss-fac-root]';

  const buildQuoteUrl = (baseUrl, s) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'facilities-commercial-buildings');
      url.searchParams.set('population', s.population.value);
      url.searchParams.set('responsibility', s.responsibility.value);
      url.searchParams.set('action', s.action.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=facilities-commercial-buildings&population=${encodeURIComponent(s.population.value)}&responsibility=${encodeURIComponent(s.responsibility.value)}&action=${encodeURIComponent(s.action.value)}`;
    }
  };

  const getRouteCopy = (s) => {
    const population = {
      'facilities-batteries': {
        sentence: 'Because these are facilities or maintenance batteries, the building can often control charger compatibility, return inspection, peak charging demand and a defined damaged-battery route.',
        priority: 'Battery/charger control, return inspection and removable-battery charging evidence'
      },
      'workplace-devices': {
        sentence: 'For ordinary workplace electronics, start with serviceable devices, intended chargers, electrical housekeeping and damaged-device reporting rather than assuming specialist containment is required.',
        priority: 'Routine-device charging, personal-device policy and damaged-device reporting'
      },
      'micromobility': {
        sentence: 'Micromobility adds larger removable batteries, personal ownership, charger provenance, access, security and indoor-versus-external policy questions.',
        priority: 'Accepted equipment, intended chargers, access/security and indoor-versus-external arrangement'
      },
      'damaged-eol': {
        sentence: 'Damaged and end-of-life batteries should be separated by condition: ordinary retired batteries, damaged/defective batteries and transport-ready batteries may require different controls.',
        priority: 'Condition-based segregation, isolation, recycler route and transport requirements'
      },
      'mixed-building': {
        sentence: 'A mixed building population needs clear boundaries between landlord, tenant, employee and contractor responsibilities so abnormal batteries do not disappear between processes.',
        priority: 'Cross-party ownership, accepted-equipment rules and one damaged-battery escalation route'
      }
    }[s.population.value];

    const responsibility = {
      'building-facilities': {
        sentence: 'The building or facilities team has relatively strong control over location, equipment standards, inspections and the response process.',
        priority: 'Facilities ownership of charging locations, inspections, alarms and final disposition'
      },
      'tenant': {
        sentence: 'Tenant-controlled batteries still interact with landlord-controlled fire strategy, common areas and building rules, so responsibilities and information-sharing should be explicit.',
        priority: 'Lease / tenant responsibility, common-area rules and landlord escalation interface'
      },
      'employee-visitor': {
        sentence: 'Personally owned equipment reduces the building operator’s control over battery history and charger provenance, increasing the importance of clear acceptance and charging policy.',
        priority: 'Personal-device acceptance, charging policy and response to abnormal equipment'
      },
      'contractor': {
        sentence: 'Contractor equipment may enter and leave the site frequently, so project/building rules need to connect with the contractor’s own battery and damaged-equipment procedures.',
        priority: 'Contractor equipment rules, temporary charging locations and handoff responsibilities'
      },
      'shared': {
        sentence: 'Shared responsibility requires one visible route across landlord, tenants, contractors and facilities so ownership does not become a gap in the safety process.',
        priority: 'Coordinated landlord/tenant/contractor policy and clear escalation ownership'
      }
    }[s.responsibility.value];

    const action = {
      'routine-charging': {
        title: 'Routine charging should solve compatibility, electrical demand and location before specialist containment is assumed.',
        copy: 'Define what is charging, how many positions operate at once, who controls the equipment and what happens if battery condition changes.',
        priorities: ['Peak charging demand and manufacturer-intended charging equipment', 'Location, electrical supply, supervision and out-of-hours responsibility']
      },
      'storage': {
        title: 'Storage should match battery condition, ownership and the next intended use.',
        copy: 'Separate serviceable inventory from damaged or uncertain items, then confirm quantity, physical fit, environment, access and security.',
        priorities: ['Serviceable inventory quantity, physical fit and environmental requirements', 'Status identification, access control and separation from abnormal batteries']
      },
      'storage-charging': {
        title: 'Combined storage and charging needs both inventory control and electrical planning.',
        copy: 'Total battery population, simultaneous charging demand and the routes for charged, awaiting-charge and damaged items should remain distinct.',
        priorities: ['Total inventory versus simultaneously charging batteries', 'Electrical load, charged/awaiting-charge flow and abnormal-battery route']
      },
      'centralise': {
        title: 'Centralising battery activity can improve control — but only if the new location fits the building.',
        copy: 'A defined charging/storage area can simplify access, supervision, alarms and inspection, but siting, electrical supply, occupancy and emergency access still need to be resolved.',
        priorities: ['Which distributed activities should move into the central area', 'Siting, electrical capacity, access, monitoring and emergency response']
      },
      'isolate': {
        title: 'A damaged or abnormal battery should leave normal building circulation.',
        copy: 'Define who can stop use, where the item is held, how it is monitored and who owns assessment, return, recycling or disposal.',
        priorities: ['Observable condition and immediate removal from routine charging/use', 'Isolation location, responsible party, monitoring and disposition route']
      },
      'return-recycle': {
        title: 'Return, recycling and transport are separate from stationary storage.',
        copy: 'Confirm battery condition, destination, recycler/carrier requirements and the exact packaging or documentation route before the battery leaves the building.',
        priorities: ['Battery condition, destination and normal-versus-damaged waste route', 'Packaging/approval basis, carrier/recycler and responsible person']
      }
    }[s.action.value];

    return {
      title: action.title,
      copy: `${action.copy} ${population.sentence} ${responsibility.sentence}`,
      priorities: [action.priorities[0], action.priorities[1], population.priority, responsibility.priority]
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.facInitialized === 'true') return;
    const selector = root.querySelector('[data-fac-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const actionLink = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const s = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        s[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return s;
    };

    const render = () => {
      const s = getSelections();
      const route = getRouteCopy(s);
      const label = `${s.population.label} · ${s.responsibility.label} · ${s.action.label}`;

      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;

      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((item) => {
          const li = document.createElement('li');
          li.textContent = item;
          priorities.appendChild(li);
        });
      }

      if (actionLink) actionLink.href = buildQuoteUrl(baseQuoteUrl, s);
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.facInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-healthcare-laboratories-research"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-bss-hlr-root]';

  const buildQuoteUrl = (baseUrl, s) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'healthcare-laboratories-research');
      url.searchParams.set('device', s.device.value);
      url.searchParams.set('environment', s.environment.value);
      url.searchParams.set('task', s.task.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=healthcare-laboratories-research&device=${encodeURIComponent(s.device.value)}&environment=${encodeURIComponent(s.environment.value)}&task=${encodeURIComponent(s.task.value)}`;
    }
  };

  const getRouteCopy = (s) => {
    const device = {
      'clinical-device': {
        sentence: 'A complete medical device remains inside the regulated clinical-device system, so OEM instructions and Clinical Engineering approval take priority over generic battery-cabinet logic.',
        priority: 'OEM charging configuration, Clinical Engineering approval and patient-care continuity'
      },
      'medical-battery': {
        sentence: 'A spare or removable medical-device battery may be managed separately from the complete device, but compatibility, labelling and the medical-device governance route still matter.',
        priority: 'Battery/device compatibility, storage condition, traceability and manufacturer / Clinical Engineering process'
      },
      'commercial-lab': {
        sentence: 'A commercially manufactured laboratory battery can often use standard storage/charging controls when operated within its intended envelope and the product evidence matches the duty.',
        priority: 'Commercial battery provenance, energy/loading basis, charging method and laboratory integration'
      },
      'prototype-research': {
        sentence: 'A modified, custom-built or experimental battery requires site-specific research risk assessment before ordinary storage or charging products are selected.',
        priority: 'Research risk assessment, battery design/test history, experiment limits and specialist engineering boundary'
      },
      'damaged-recalled': {
        sentence: 'A damaged, recalled or end-of-life battery has left normal service and needs a defined technical owner, controlled holding route and final disposition.',
        priority: 'Condition, recall/fault status, responsible owner, isolation and return/disposal route'
      }
    }[s.device.value];

    const environment = {
      'clinical-area': {
        sentence: 'In clinical care or an equipment library, device availability and patient-care continuity are as important as battery safety.',
        priority: 'Clinical readiness, equipment availability, cleaning/inspection handoff and clinical escalation'
      },
      'clinical-engineering': {
        sentence: 'Clinical Engineering can provide the technical control point for battery replacement, recalls, abnormal-device intake and approval of charging/storage changes.',
        priority: 'Technical acceptance, service records, spare inventory, recall management and abnormal-device routing'
      },
      'general-lab': {
        sentence: 'A general laboratory adds bench layout, room conditions, local procedures, unattended operation and EHS/fire-safety interfaces.',
        priority: 'Bench/room integration, quantity, unattended charging, local monitoring and EHS procedure'
      },
      'battery-rd': {
        sentence: 'A battery R&D or test laboratory may intentionally operate cells outside ordinary product conditions, so the experiment hazard basis must drive containment and monitoring.',
        priority: 'Test profile, energy, chemistry, gases, failure modes, specialist chamber/room engineering and EHS approval'
      },
      'central-ehs': {
        sentence: 'A central EHS or storage area can standardise abnormal-battery holding, waste, shipping and institution-level procedures across departments.',
        priority: 'Institutional intake criteria, segregation, monitoring, waste/return route and dangerous-goods responsibility'
      }
    }[s.environment.value];

    const task = {
      'routine-readiness': {
        title: 'Routine charging should preserve the intended system and the operational purpose of the battery.',
        copy: 'Confirm the approved charger, charging location, capacity, supervision and status workflow before adding any third-party enclosure.',
        priorities: ['Charging compatibility and electrical arrangement', 'Availability / readiness of the device or battery inventory']
      },
      'storage': {
        title: 'Storage should match battery condition, provenance and the next intended use.',
        copy: 'Separate serviceable inventory from damaged, experimental or recalled batteries, then confirm quantity, environment, access and traceability.',
        priorities: ['Serviceable inventory, physical fit and environmental conditions', 'Status identification, traceability and separation from abnormal batteries']
      },
      'storage-charging': {
        title: 'Combined storage and charging needs both technical evidence and operating workflow.',
        copy: 'Define the battery population, simultaneous charging demand, charger arrangement, alarms and route for abnormal batteries before comparing cabinets.',
        priorities: ['Battery energy/loading basis and simultaneous charging demand', 'Electrical setup, monitoring, alarms and abnormal-battery route']
      },
      'experimental-test': {
        title: 'Experimental battery use requires the research hazard basis before product selection.',
        copy: 'Define chemistry, cell/pack architecture, charge/discharge limits, test environment, failure modes and emergency response before choosing supporting storage or containment equipment.',
        priorities: ['Documented experiment / research risk assessment', 'Specialist test engineering where batteries are modified, deliberately stressed or abused']
      },
      'isolate': {
        title: 'An abnormal battery should leave normal clinical or laboratory circulation.',
        copy: 'Define who owns the battery, whether it should be moved, the controlled holding location and the return, recall, recycling or specialist disposition route.',
        priorities: ['Observable condition and stop to normal charging/use', 'Isolation suitability, monitoring, technical owner and final disposition']
      },
      'ship-dispose': {
        title: 'Shipping and disposal require battery identity and condition before packaging is selected.',
        copy: 'Confirm whether the battery is commercial, prototype, recalled or damaged, then apply the relevant institutional shipping, carrier and dangerous-goods process.',
        priorities: ['Battery identity, condition and test/recall history', 'Transport packaging basis, carrier, documentation and destination']
      }
    }[s.task.value];

    if (s.device.value === 'prototype-research' || s.task.value === 'experimental-test' || s.environment.value === 'battery-rd') {
      return {
        title: 'Research risk assessment comes before ordinary product selection.',
        copy: `${task.copy} ${device.sentence} ${environment.sentence}`,
        priorities: [
          'Document battery chemistry, architecture, energy, SOC and experiment/test conditions',
          'Identify expected and credible abnormal/failure modes',
          'Use EHS / laboratory engineering review to define containment, ventilation, monitoring and emergency controls',
          'Select BSS storage, isolation or transport equipment only for the supporting functions the assessment identifies'
        ],
        specialist: true
      };
    }

    return {
      title: task.title,
      copy: `${task.copy} ${device.sentence} ${environment.sentence}`,
      priorities: [task.priorities[0], task.priorities[1], device.priority, environment.priority],
      specialist: false
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.hlrInitialized === 'true') return;

    const selector = root.querySelector('[data-hlr-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const s = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        s[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return s;
    };

    const render = () => {
      const s = getSelections();
      const route = getRouteCopy(s);
      const label = `${s.device.label} · ${s.environment.label} · ${s.task.label}`;

      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;

      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((item) => {
          const li = document.createElement('li');
          li.textContent = item;
          priorities.appendChild(li);
        });
      }

      if (action) {
        action.href = buildQuoteUrl(baseQuoteUrl, s);
        action.innerHTML = route.specialist
          ? 'Continue to specialist requirement capture <span aria-hidden="true">→</span>'
          : 'Continue this requirement in the Guided Quote <span aria-hidden="true">→</span>';
      }
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.hlrInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-manufacturing-industrial-operations"] && !Shopify.designMode) return;
  try {
    
(() => {
 const rootSelector='[data-bss-mio-root]';
 const qurl=(base,s)=>{try{const u=new URL(base||'/pages/request-a-quote',location.origin);u.searchParams.set('industry','manufacturing-industrial-operations');u.searchParams.set('role',s.role.value);u.searchParams.set('location',s.location.value);u.searchParams.set('task',s.task.value);return u.origin===location.origin?`${u.pathname}${u.search}${u.hash}`:u.toString()}catch(e){return base}};
 const route=s=>{
  const roles={
   'portable-work':['Removable work batteries are often well suited to controlled storage/charging when battery families, charger compatibility, inventory and shift demand are defined.','Inventory, simultaneous charging, charger compatibility and operator workflow'],
   'motive-power':['Forklifts, AGVs and AMRs frequently use integrated battery/charger/vehicle systems, so the OEM charging architecture should remain the primary route.','OEM vehicle/battery/charger compatibility, opportunity charging and uptime'],
   'production-inventory':['Production components, WIP and finished goods can become a larger fire-protection/code problem as quantity, packaging, SOC and storage arrangement increase.','Inventory status, quantity, SOC, packaging, arrangement and code/insurer/AHJ review'],
   'central-spares':['Central spare inventory can benefit from clear serviceable-battery status, rotation, charging capacity and a separate abnormal-battery route.','Serviceable inventory, rotation, technical ownership and abnormal-battery segregation'],
   'abnormal':['A damaged, rejected, recalled or end-of-life battery has left normal service and needs a controlled technical owner, holding route and disposition.','Condition, incident/recall history, isolation, movement decision and disposition']
  }[s.role.value];
  const locs={
   'production-line':['At the production line or point of use, the control must remain practical enough to support operations without encouraging bypass behaviour.','Production-critical availability, point-of-use practicality and local electrical/fire environment'],
   'mro-toolcrib':['An MRO/tool-crib location can centralise issue, inspection, charging and abnormal-battery routing under technical ownership.','Issue/return workflow, charging capacity, technician access and status control'],
   'warehouse-stores':['Warehouse/stores add inventory quantity, packaging, rack/floor arrangement, sprinkler/fire protection and receiving/reject considerations.','Quantity, packaging, arrangement, fire protection and code/insurer review'],
   'dedicated-area':['A dedicated battery area can consolidate higher-capacity charging/storage but must be integrated with room, electrical infrastructure, alarms and fire strategy.','Room design, electrical load, ventilation, monitoring, egress and capacity'],
   'internal-logistics':['Internal logistics needs a defined handling method and destination while preserving the distinction from external dangerous-goods transport.','Handling route, payload, condition, containment and transport boundary'],
   'battery-process':['Battery manufacturing/cell processes can introduce chemical, process, occupational and fire hazards requiring specialist engineering beyond ordinary cabinet selection.','Process hazard analysis, occupational hygiene, ventilation/LEV and fire/explosion engineering']
  }[s.location.value];
  const tasks={
   'routine-charge':['Balance charging control with production uptime.','Confirm inventory, simultaneous charging demand, shift pattern, charger compatibility, electrical load and point-of-use requirements before centralising or distributing charging.',['Inventory versus simultaneous charging demand','OEM-compatible charging and electrical load']],
   'store-stage':['Storage and staging should follow battery status and its next operational step.','Separate serviceable inventory from rejected/abnormal batteries, then define quantity, packaging, access, duration and surrounding fire protection.',['Battery status, quantity, packaging and duration','Fire protection, location and segregation']],
   'storage-charging':['Combined storage and charging needs both technical evidence and operational fit.','Define battery population, charging demand, electrical configuration, alarms and abnormal-battery route before comparing solutions.',['Battery energy/loading basis and charging demand','Electrical configuration, monitoring and abnormal-battery route']],
   'move-internally':['Internal movement needs a defined handling method and destination.','Confirm condition, payload, route, handling equipment and destination.',['Battery condition, route and internal containment','Clear separation from external transport approval']],
   'isolate':['An abnormal battery should leave the ordinary production or inventory stream.','Define who owns it, whether movement is appropriate, temporary holding and final disposition.',['Observable condition and stop to normal use','Isolation suitability, monitoring, owner and disposition']],
   'ship-dispose':['External return or disposal requires battery identity and condition before packaging is selected.','Confirm serviceable/recalled/rejected/damaged status, then apply the relevant carrier, dangerous-goods, packaging and destination process.',['Battery identity, condition and transport classification','Packaging, carrier, documentation and destination']]
  }[s.task.value];
  if(s.location.value==='battery-process') return {title:'Specialist process-safety assessment comes before ordinary product selection.',copy:`${locs[0]} Define the specific supporting storage, isolation or transport duty before selecting BSS equipment.`,p:['Define the battery-manufacturing process and hazardous materials involved','Use specialist process-safety / occupational-hygiene / fire-engineering review','Identify only the supporting functions BSS should address','Do not use a cabinet as a substitute for source-control or process-safety engineering'],special:true};
  if(s.role.value==='motive-power'&&(s.task.value==='routine-charge'||s.task.value==='storage-charging')) return {title:'Confirm the OEM motive-power charging system first.',copy:`${roles[0]} ${locs[0]} BSS should address surrounding storage, abnormal-battery isolation, fire planning and transport only where separately defined.`,p:['Vehicle + battery + charger compatibility','OEM opportunity-charging / fleet-energy strategy','Production or warehouse uptime and charger locations','Separate damaged-battery, spare-battery and incident routes'],special:true};
  if(s.role.value==='production-inventory'&&(s.location.value==='warehouse-stores'||s.location.value==='dedicated-area')) return {title:'Bulk inventory may need fire-code, insurer and engineering review before cabinet selection.',copy:`${roles[0]} ${locs[0]} Define quantity, SOC, packaging, rack/floor arrangement and existing fire protection before deciding whether a cabinet-scale solution is appropriate.`,p:['Inventory quantity, battery energy and state of charge','Packaging, rack/floor arrangement and storage duration','Sprinkler/fire-protection system and room configuration','Local code/AHJ and insurer/loss-prevention review'],special:true};
  return {title:tasks[0],copy:`${tasks[1]} ${roles[0]} ${locs[0]}`,p:[tasks[2][0],tasks[2][1],roles[1],locs[1]],special:false};
 };
 const init=root=>{if(!root||root.dataset.mioInitialized==='true')return;const box=root.querySelector('[data-mio-model-selector]');if(!box)return;const groups=[...box.querySelectorAll('[data-decision-group]')],out=box.querySelector('[data-decision-output]'),kick=box.querySelector('[data-decision-kicker]'),title=box.querySelector('[data-decision-title]'),copy=box.querySelector('[data-decision-copy]'),plist=box.querySelector('[data-decision-priorities]'),action=box.querySelector('[data-decision-action]'),base=root.dataset.quoteUrl||'/pages/request-a-quote';const sel=()=>{const s={};groups.forEach(g=>{const b=g.querySelector('.is-active')||g.querySelector('[data-decision-value]');s[g.dataset.decisionGroup]={value:b.dataset.decisionValue,label:b.dataset.decisionLabel||b.textContent.trim()}});return s};const render=()=>{const x=sel(),r=route(x),label=`${x.role.label} · ${x.location.label} · ${x.task.label}`;out.textContent=label;kick.textContent=label;title.textContent=r.title;copy.textContent=r.copy;plist.innerHTML='';r.p.forEach(v=>{const li=document.createElement('li');li.textContent=v;plist.appendChild(li)});action.href=qurl(base,x);action.innerHTML=(r.special?'Continue to specialist requirement capture':'Continue this requirement in the Guided Quote')+' <span aria-hidden="true">→</span>'};groups.forEach(g=>{const bs=[...g.querySelectorAll('[data-decision-value]')];bs.forEach((b,i)=>{b.addEventListener('click',()=>{bs.forEach(x=>{const a=x===b;x.classList.toggle('is-active',a);x.setAttribute('aria-pressed',String(a))});render()});b.addEventListener('keydown',e=>{let n=null;if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(i+1)%bs.length;if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(i-1+bs.length)%bs.length;if(e.key==='Home')n=0;if(e.key==='End')n=bs.length-1;if(n!==null){e.preventDefault();bs[n].focus();bs[n].click()}})})});render();root.dataset.mioInitialized='true'};
 const all=(c=document)=>{if(c.matches&&c.matches(rootSelector))init(c);if(c.querySelectorAll)c.querySelectorAll(rootSelector).forEach(init)};all();document.addEventListener('shopify:section:load',e=>all(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-residential-property-shared-buildings"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-bss-res-root]';

  const buildQuoteUrl = (baseUrl, s) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'residential-shared-buildings');
      url.searchParams.set('building', s.building.value);
      url.searchParams.set('activity', s.activity.value);
      url.searchParams.set('goal', s.goal.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=residential-shared-buildings&building=${encodeURIComponent(s.building.value)}&activity=${encodeURIComponent(s.activity.value)}&goal=${encodeURIComponent(s.goal.value)}`;
    }
  };

  const getRouteCopy = (s) => {
    const building = {
      'private-home': {
        sentence: 'In a private dwelling, management control is limited and the starting point is usually resident behaviour, manufacturer instructions, battery condition and a suitable charging location.',
        priority: 'Resident guidance, intended charging equipment and escape-route awareness'
      },
      'apartment-condo': {
        sentence: 'An apartment or condo adds common areas, cycle storage and shared fire/building responsibilities while much battery activity remains resident-controlled.',
        priority: 'Private-unit versus common-area boundaries, resident communication and shared-infrastructure options'
      },
      'social-housing': {
        sentence: 'Managed social or affordable housing benefits from practical, equitable solutions that can be repeated across multiple buildings without assuming every property has the same layout.',
        priority: 'Resident needs, portfolio consistency, site exceptions and maintainable shared facilities'
      },
      'senior-accessible': {
        sentence: 'Senior or accessible housing requires particular care where residents depend on powered mobility equipment and need dependable, accessible charging.',
        priority: 'Accessibility, resident dependency, charging continuity and equipment-specific arrangements'
      },
      'student-coliving': {
        sentence: 'Student or co-living settings can combine high turnover, personal devices and micromobility, increasing the value of simple rules and easy-to-use shared facilities.',
        priority: 'High-turnover communication, personal-device policy, access and shared amenity operation'
      },
      'portfolio': {
        sentence: 'A multi-site portfolio can standardise policy, procurement fields and core solution formats while allowing site-specific exceptions for layout and local requirements.',
        priority: 'Portfolio specification, repeat procurement, local exceptions and multi-site support'
      }
    }[s.building.value];

    const activity = {
      'micromobility': {
        sentence: 'E-bikes and e-scooters bring larger removable or integrated batteries, charger compatibility, security and resident behaviour into the building-management decision.',
        priority: 'Product/charger provenance, charging location, security and resident uptake'
      },
      'mobility-aid': {
        sentence: 'Mobility equipment should be treated according to resident dependency and accessibility needs rather than simply copied from recreational micromobility policy.',
        priority: 'Accessibility, resident-specific need, reliable charging and safe building location'
      },
      'household-tool': {
        sentence: 'Ordinary phones, laptops and household/tool batteries do not automatically require specialised communal containment; condition, charger use and location remain proportionate controls.',
        priority: 'Routine product use, intended chargers, damaged-battery reporting and proportionate controls'
      },
      'damaged': {
        sentence: 'A damaged or defective battery leaves the normal resident-use pathway. The building needs a defined reporting and specialist disposition route rather than asking residents to improvise.',
        priority: 'Stop normal use, assess whether movement is appropriate, isolate where suitable and define disposition'
      },
      'mixed-unknown': {
        sentence: 'A mixed or poorly understood resident battery population makes user survey, building policy and acceptance criteria especially important before infrastructure is sized.',
        priority: 'Resident survey, battery population visibility, accepted-equipment rules and future growth'
      }
    }[s.activity.value];

    const goal = {
      'resident-guidance': {
        title: 'Start with clear resident guidance before assuming new infrastructure is necessary.',
        copy: 'Define accepted equipment, intended charging practice, unsuitable locations, abnormal-battery reporting and the building contact point.',
        priorities: ['Resident rules that are simple enough to follow', 'Clear reporting and escalation when battery condition changes']
      },
      'move-out-of-dwellings': {
        title: 'Moving charging out of dwellings works best when the alternative is secure and convenient.',
        copy: 'Understand why residents currently charge where they do, then compare whole-bike, removable-battery or dedicated-area options that can realistically change behaviour.',
        priorities: ['Current charging behaviour and the reasons residents choose it', 'Location, security, capacity and access of the proposed alternative']
      },
      'shared-storage': {
        title: 'Shared storage solves security and location — but does not automatically solve charging.',
        copy: 'A secure cycle or battery area can reduce inappropriate common-area storage, but residents may still remove batteries and charge elsewhere if no charging route is provided.',
        priorities: ['Vehicle/battery security and resident access', 'Whether lack of charging causes batteries to return to dwellings']
      },
      'shared-charging': {
        title: 'Shared charging needs resident usability, electrical capacity and building integration together.',
        copy: 'Compare whole-bike and removable-battery formats, peak demand, access, security, intended chargers and what happens when all positions are occupied.',
        priorities: ['Peak resident demand, charging format and electrical supply', 'Access, security, payment/reservation and capacity management']
      },
      'storage-charging': {
        title: 'Combined storage and charging can turn a policy into a usable resident amenity.',
        copy: 'A managed system should coordinate security, charging, resident access, monitoring and maintenance without implying that every product has the same fire-performance capability.',
        priorities: ['Security + charging fit for the resident fleet', 'Monitoring, maintenance, building location and exact product evidence']
      },
      'damaged-route': {
        title: 'A damaged-battery process must protect residents from having to improvise.',
        copy: 'Define who receives the report, whether the battery should be moved, what controlled holding is available and how the battery reaches the manufacturer, retailer or recycler.',
        priorities: ['Resident reporting and instruction not to continue normal charging/use', 'Isolation, responsible person, recycler/return and transport route']
      }
    }[s.goal.value];

    if (s.activity.value === 'damaged') {
      return {
        title: 'A damaged or defective battery should leave normal resident use before any ordinary charging or storage decision.',
        copy: `Stop normal charging/use and follow the building/manufacturer procedure. Do not assume the resident should carry a suspect battery through the building to reach a container. ${building.sentence}`,
        priorities: [
          'Observable condition and immediate stop to normal use/charging',
          'Whether movement is appropriate before any isolation attempt',
          'Named building contact and controlled holding/disposition route',
          building.priority
        ]
      };
    }

    return {
      title: goal.title,
      copy: `${goal.copy} ${activity.sentence} ${building.sentence}`,
      priorities: [goal.priorities[0], goal.priorities[1], activity.priority, building.priority]
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.resInitialized === 'true') return;

    const selector = root.querySelector('[data-res-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const s = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        s[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return s;
    };

    const render = () => {
      const s = getSelections();
      const route = getRouteCopy(s);
      const label = `${s.building.label} · ${s.activity.label} · ${s.goal.label}`;

      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;

      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((item) => {
          const li = document.createElement('li');
          li.textContent = item;
          priorities.appendChild(li);
        });
      }

      if (action) action.href = buildQuoteUrl(baseQuoteUrl, s);
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;

          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.resInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-schools-education"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-bss-edu-root]';

  const buildQuoteUrl = (baseUrl, s) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'schools-education');
      url.searchParams.set('population', s.population.value);
      url.searchParams.set('activity', s.activity.value);
      url.searchParams.set('location', s.location.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=schools-education&population=${encodeURIComponent(s.population.value)}&activity=${encodeURIComponent(s.activity.value)}&location=${encodeURIComponent(s.location.value)}`;
    }
  };

  const getRouteCopy = (s) => {
    const population = {
      'managed-devices': {
        sentence: 'Because this is a managed laptop/tablet population, device availability, intended chargers, electrical loading, ventilation, security and the damaged-device route should be resolved before higher-spec containment is assumed.',
        priority: 'Device/charger compatibility, charging-cart function and separate damaged-device workflow'
      },
      'removable-tools': {
        sentence: 'Removable tool and facilities batteries behave more like a managed battery fleet: charger compatibility, return inspection, peak charging demand and physical damage exposure become more important.',
        priority: 'Battery/charger control, return inspection and removable-battery storage/charging evidence'
      },
      'cte-specialist': {
        sentence: 'CTE, robotics and specialist packs can vary widely in chemistry, configuration and supervision needs; modified or custom systems may require site-specific technical assessment.',
        priority: 'Commercial versus modified/custom battery status, technical supervision and pack-specific requirements'
      },
      'micromobility': {
        sentence: 'E-bike and e-scooter batteries add personal ownership, larger removable packs, charger provenance, campus access and indoor-versus-external policy questions.',
        priority: 'Accepted equipment policy, charger provenance, access/security and indoor-versus-external arrangement'
      },
      'mixed-campus': {
        sentence: 'A mixed campus population needs clear boundaries between IT, teaching, facilities and personal equipment so that one department does not assume another owns the battery risk.',
        priority: 'Cross-department ownership, accepted-equipment rules and one damaged-battery escalation route'
      }
    }[s.population.value];

    const activity = {
      'routine-charging': {
        title: 'Routine charging should solve availability, compatibility and electrical demand before extra containment is assumed.',
        copy: 'Define what is charging, how many positions operate at once, which chargers are intended, who can access the equipment and what happens if condition changes.',
        priorities: ['Peak charging positions and actual charger/device input ratings', 'Charging schedule, supervision, ventilation and user access']
      },
      'storage': {
        title: 'Storage should match battery condition, ownership and the next intended use.',
        copy: 'Separate serviceable inventory from damaged or uncertain items, then confirm quantity, physical fit, environmental conditions, security and whether batteries remain connected to charging equipment.',
        priorities: ['Serviceable inventory quantity, physical fit and environmental requirements', 'Security, status identification and separation from damaged/uncertain batteries']
      },
      'storage-charging': {
        title: 'Combined storage and charging needs both inventory control and electrical planning.',
        copy: 'Total battery/device population, simultaneously charging positions and the route for charged, awaiting-charge and damaged items should remain distinct.',
        priorities: ['Total inventory versus simultaneous charging demand', 'Charged/awaiting-charge flow, electrical load and abnormal-battery route']
      },
      'damaged-return': {
        title: 'A damaged, swollen or abnormal battery should leave the normal education charging workflow.',
        copy: 'Define who can stop use, where the item is held, what information follows it and who owns assessment, warranty return, recycling or disposal.',
        priorities: ['Observable condition, incident history and immediate removal from normal charging', 'IT/EHS/facilities ownership, isolation location and disposition route']
      },
      'move-dispose': {
        title: 'Movement, warranty return and disposal are separate from stationary storage.',
        copy: 'Confirm battery/device condition, destination, internal or external movement, carrier requirements and the exact packaging or disposal route before transfer.',
        priorities: ['Battery condition, destination and internal/external transport route', 'Packaging/approval basis, responsible person and recycling/warranty documentation']
      }
    }[s.activity.value];

    const location = {
      'classroom-it': { sentence: 'The classroom/IT context adds high occupancy, pupil access, cable management, security and escape-route considerations.', priority: 'Pupil access, device security, escape routes and IT ownership' },
      'workshop-cte': { sentence: 'The workshop/CTE context adds practical handling, removable batteries, physical damage exposure and technical supervision.', priority: 'Practical-work supervision, physical damage exposure and workshop charging controls' },
      'facilities-depot': { sentence: 'The facilities/grounds context adds tool-fleet throughput, mixed equipment, depot charging and out-of-hours responsibility.', priority: 'Central depot workflow, mixed equipment, charger control and out-of-hours charging' },
      'external-micromobility': { sentence: 'The external micromobility context adds weather, public access, theft/security and institution policy.', priority: 'Weather rating, public access, security, accepted equipment and site location' },
      'central-service': { sentence: 'The central service context can improve control of repair intake, damaged devices, inventory and district/campus-wide standardisation.', priority: 'Intake status, segregation, procurement standardisation and final disposition ownership' }
    }[s.location.value];

    return {
      title: activity.title,
      copy: `${activity.copy} ${population.sentence} ${location.sentence}`,
      priorities: [activity.priorities[0], activity.priorities[1], population.priority, location.priority]
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.eduInitialized === 'true') return;
    const selector = root.querySelector('[data-edu-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const s = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        s[group.dataset.decisionGroup] = {
          value: selected ? selected.dataset.decisionValue : '',
          label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : ''
        };
      });
      return s;
    };

    const render = () => {
      const s = getSelections();
      const route = getRouteCopy(s);
      const label = `${s.population.label} · ${s.activity.label} · ${s.location.label}`;
      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;
      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((item) => {
          const li = document.createElement('li');
          li.textContent = item;
          priorities.appendChild(li);
        });
      }
      if (action) action.href = buildQuoteUrl(baseQuoteUrl, s);
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });

        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== null) {
            event.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      });
    });

    render();
    root.dataset.eduInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bss-utilities-telecoms-field-service"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rootSelector = '[data-bss-field-root]';

  const buildQuoteUrl = (baseUrl, s) => {
    try {
      const url = new URL(baseUrl || '/pages/request-a-quote', window.location.origin);
      url.searchParams.set('industry', 'utilities-telecoms-field-service');
      url.searchParams.set('lifecycle', s.lifecycle.value);
      url.searchParams.set('task', s.task.value);
      url.searchParams.set('site_type', s.site_type.value);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : url.toString();
    } catch (error) {
      const separator = String(baseUrl).includes('?') ? '&' : '?';
      return `${baseUrl}${separator}industry=utilities-telecoms-field-service&lifecycle=${encodeURIComponent(s.lifecycle.value)}&task=${encodeURIComponent(s.task.value)}&site_type=${encodeURIComponent(s.site_type.value)}`;
    }
  };

  const getRouteCopy = (s) => {
    const lifecycle = {
      'installed-unattended': {
        sentence: 'Because the battery is installed at an unattended site, remote visibility, environmental conditions and response ownership become central.',
        priority: 'Remote alarms, communications path and field-response ownership'
      },
      'installed-staffed': {
        sentence: 'Because the battery is installed at a staffed facility, local supervision can support detection and maintenance, but system/OEM and site requirements still govern.',
        priority: 'Local inspection, controlled access and site escalation procedures'
      },
      'replacement-spares': {
        sentence: 'Replacement inventory should remain identifiable, serviceable and stored under documented conditions before dispatch.',
        priority: 'Inventory segregation, environmental storage limits and dispatch readiness'
      },
      'removed-failed': {
        sentence: 'A removed or failed battery has left normal service and should not automatically re-enter spare inventory or routine transport.',
        priority: 'Condition classification, controlled holding and disposition ownership'
      },
      'field-vehicle': {
        sentence: 'A field-service vehicle can combine replacement inventory, removed batteries and tools, so storage, securement and transport duties should be kept separate.',
        priority: 'Vehicle securement, environmental exposure and separation of battery states'
      }
    }[s.lifecycle.value];

    const task = {
      'monitor-maintain': {
        title: 'Monitoring only helps when its scope, signal path and human response are defined.',
        copy: 'Confirm what the battery/BMS and site sensors actually measure, where alarms go, who owns the response and how quickly someone can reach the site.',
        priorities: ['OEM/BMS monitoring scope and stated limitations', 'Alarm forwarding, loss-of-comms behavior and response criteria']
      },
      'store': {
        title: 'Storage should match battery state, environment and the next planned use.',
        copy: 'Define whether the inventory is new/serviceable, removed/used or uncertain, then confirm environmental limits, quantity, physical fit, security and monitoring before choosing a storage format.',
        priorities: ['Battery condition, quantity, dimensions and documented storage limits', 'Indoor/outdoor environment, security and monitoring requirements']
      },
      'install-replace': {
        title: 'Replacement connects the engineered power system to the field-service battery lifecycle.',
        copy: 'Use the OEM/system procedure for the installed electrical work, while separately planning replacement inventory, lifting/access, the removed battery and its return route.',
        priorities: ['OEM/system installation procedure and battery identity', 'Handling access, replacement logistics and removed-battery disposition']
      },
      'isolate': {
        title: 'A damaged, defective or uncertain battery needs a separate controlled route.',
        copy: 'Do not place an abnormal removed battery into normal spare inventory. Establish condition, suitable stationary isolation, monitoring and the next assessment/return/recycling decision.',
        priorities: ['Observed condition and reason for removal', 'Isolation product condition suitability, monitoring and limitations']
      },
      'move-transport': {
        title: 'Transport is a separate regulatory and packaging decision.',
        copy: 'Confirm battery condition, dimensions, mass, destination, transport mode and the exact packaging/permit basis. A stationary enclosure or isolation box is not automatically transport packaging.',
        priorities: ['Battery condition, dimensions, mass and transport classification', 'Packaging/permit basis, carrier, securement and destination']
      }
    }[s.task.value];

    const site = {
      'telecom-ran': { sentence: 'The telecom/RAN context adds network-availability, remote-access and alarm-response considerations.', priority: 'Network resilience requirement and remote site access time' },
      'roadside-outdoor': { sentence: 'The outdoor/roadside context adds weather, restricted space, security and public-exposure considerations.', priority: 'NEMA/IP evidence, temperature, condensation, access and security' },
      'utility-comms': { sentence: 'The utility/communications context adds continuity, operator standards and critical-control interfaces.', priority: 'Operator/site standards, continuity requirement and controlled access' },
      'field-depot': { sentence: 'The field-depot context brings replacement stock, returns, charging where applicable and transport together.', priority: 'Inventory segregation, charging/handling workflow and return logistics' },
      'remote-offgrid': { sentence: 'The remote/off-grid context makes access time, alternative power and communication resilience especially important.', priority: 'Alternative power interfaces, access time and alarm communications resilience' }
    }[s.site_type.value];

    return {
      title: task.title,
      copy: `${task.copy} ${lifecycle.sentence} ${site.sentence}`,
      priorities: [task.priorities[0], task.priorities[1], lifecycle.priority, site.priority]
    };
  };

  const initialize = (root) => {
    if (!root || root.dataset.fieldInitialized === 'true') return;
    const selector = root.querySelector('[data-field-model-selector]');
    if (!selector) return;

    const groups = Array.from(selector.querySelectorAll('[data-decision-group]'));
    const output = selector.querySelector('[data-decision-output]');
    const kicker = selector.querySelector('[data-decision-kicker]');
    const title = selector.querySelector('[data-decision-title]');
    const copy = selector.querySelector('[data-decision-copy]');
    const priorities = selector.querySelector('[data-decision-priorities]');
    const action = selector.querySelector('[data-decision-action]');
    const baseQuoteUrl = root.dataset.quoteUrl || '/pages/request-a-quote';

    const getSelections = () => {
      const s = {};
      groups.forEach((group) => {
        const selected = group.querySelector('[data-decision-value].is-active') || group.querySelector('[data-decision-value]');
        s[group.dataset.decisionGroup] = { value: selected ? selected.dataset.decisionValue : '', label: selected ? (selected.dataset.decisionLabel || selected.textContent.trim()) : '' };
      });
      return s;
    };

    const render = () => {
      const s = getSelections();
      const route = getRouteCopy(s);
      const label = `${s.lifecycle.label} · ${s.task.label} · ${s.site_type.label}`;
      if (output) output.textContent = label;
      if (kicker) kicker.textContent = label;
      if (title) title.textContent = route.title;
      if (copy) copy.textContent = route.copy;
      if (priorities) {
        priorities.innerHTML = '';
        route.priorities.forEach((item) => { const li = document.createElement('li'); li.textContent = item; priorities.appendChild(li); });
      }
      if (action) action.href = buildQuoteUrl(baseQuoteUrl, s);
    };

    groups.forEach((group) => {
      const buttons = Array.from(group.querySelectorAll('[data-decision-value]'));
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); });
          render();
        });
        button.addEventListener('keydown', (event) => {
          const index = buttons.indexOf(button);
          let next = null;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== null) { event.preventDefault(); buttons[next].focus(); buttons[next].click(); }
        });
      });
    });

    render();
    root.dataset.fieldInitialized = 'true';
  };

  const initializeAll = (context = document) => {
    if (context.matches && context.matches(rootSelector)) initialize(context);
    if (context.querySelectorAll) context.querySelectorAll(rootSelector).forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
